var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2133 16.4201L15.9889 5.91669H16.3022C16.7691 5.91669 17.1667 5.55612 17.1667 5.0521C17.1667 4.5829 16.7714 4.18752 16.3022 4.18752H14.5897L13.4101 2.10075C13.0693 1.58964 12.4576 1.25 11.811 1.25H7.77249C7.12586 1.25 6.51402 1.58977 6.17321 2.10091L4.99374 4.18752H3.28133C2.77732 4.18752 2.41675 4.5852 2.41675 5.0521C2.41675 5.55386 2.77958 5.91669 3.28133 5.91669H3.562L4.33754 16.4189L4.33764 16.4201C4.43904 17.5693 5.35343 18.4167 6.50399 18.4167H13.047C14.1975 18.4167 15.1119 17.5693 15.2133 16.4201ZM11.9643 3.06331L12.5001 4.18752H7.08339L7.60912 3.07942C7.65631 2.97917 7.71631 2.97917 7.77249 2.97917H11.811C11.8737 2.97917 11.9271 2.97917 11.9643 3.06331ZM6.0661 16.3068L5.29168 5.91669H14.2593L13.4848 16.3068C13.4567 16.5234 13.2658 16.6875 13.047 16.6875H6.50399C6.28515 16.6875 6.0942 16.5234 6.0661 16.3068Z",
    fill: "#DBFF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.acd1a180584b2948bf4727bc4787e8b4.svg";
export { ForwardRef as ReactComponent };